// Public Shift4Shop storefront endpoints (commerce source of truth).
// These are public URLs (not secrets) and mirror the backend store-config.
const BASE = "https://307w54281805385.s4shops.com";

export const STORE = {
  base: BASE,
  shop: `${BASE}/peptides.html`,
  cart: `${BASE}/peptides.html`,
  account: `${BASE}/account.asp`,
  search: `${BASE}/search`,
  checkout: `${BASE}/peptides.html`,
};

export const ANNOUNCEMENTS = [
  "For Laboratory Research Use Only",
  "Trusted Quality",
  "Research Focused",
  "Premium Presentation",
  "Discreet Shipping",
];

export const RESEARCH_NOTICE =
  "For laboratory research use only. Not for human or veterinary use.";

export const DISCLAIMER =
  "All products offered by Renova Peptide Co. are intended exclusively for laboratory research and analytical use. They are not intended for human or veterinary use, consumption, diagnosis, treatment, prevention, or any therapeutic purpose.";
